// Эндпоинты и типы для статистики API

export interface MyApiStatsParams {
    limit?: number;
    has_errors?: boolean;
}

export interface AllApiStatsParams {
    user_id?: number;
    endpoint?: string;
    limit?: number;
    offset?: number;
    has_errors?: boolean;
}

export interface TopEndpointsParams {
    limit?: number;
}

export interface TopUsersParams {
    limit?: number;
    from_date?: string;
    to_date?: string;
}

export const apiStatsEndpoints = {
    getMyApiStats: {
        query: (params: MyApiStatsParams) => ({
            url: "/api-stats/my",
            params,
        }),
    },

    getAllApiStats: {
        query: (params: AllApiStatsParams) => ({
            url: "/api-stats/all",
            params,
        }),
    },

    getTopEndpoints: {
        query: (params: TopEndpointsParams) => ({
            url: "/api-stats/top-endpoints",
            params,
        }),
    },

    getTopUsers: {
        query: (params: TopUsersParams) => ({
            url: "/api-stats/top-users",
            params,
        }),
    },
};

export const apiStatsTags = ["ApiStats"] as const;
